// @flow
import type {MarkdocTagRegistration} from 'docs/markdoc';

export const FilePurposesTag: MarkdocTagRegistration = {
  tag: 'file-purposes',
  children: [],
  component: 'FilePurposes',
  attributes: {
    purposesList: {
      type: Array,
      required: true,
      description: 'List of file purposes objects',
    },
  },
  description: 'File purposes table for the /docs/file-upload page',
};
